module.exports = "https://jsak.mmtcdn.com/tripmoney/static/media/BPCL SBI Card.4dbf990a.png";